import { qfetch } from './utils/http.js';
const cache = new Map();

function pad3(n) {
  const v = parseInt(n, 10);
  const safe = Number.isFinite(v) ? Math.min(114, Math.max(1, v)) : 1;
  return String(safe).padStart(3, '0');
}

function withTs(url) {
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}ts=${Date.now()}`;
}
async function getTextSurahUrl(id) {
  const p3 = pad3(id);
  return `text_surah/surah_${p3}_complete.json`;
}

export async function prefetchSurah(id) {
  const key = String(id);
  if (cache.has(key)) return cache.get(key);
  const surahUrl = await getTextSurahUrl(id);
  async function fetchJsonSafe(url) {
    try { const r = await qfetch(withTs(url), { cache: 'no-store' }); if (r.ok) return await r.json(); } catch (_) { }
    return null;
  }
  const js = await fetchJsonSafe(surahUrl);
  let surah;
  if (js && js.alquran_translations) {
    const ayahs = js.alquran_translations.ayahs || [];
    const words = ayahs.map((ay) => {
      const words_v1 = ay.words_v1 || {};
      const words_v4 = ay.words_v4 || {};
      const pages_v1 = ay.words_v1_pages || ay.pages_v1 || null;
      const pages_v4 = ay.words_v4_pages || ay.pages_v4 || null;
      const idxs = Array.from(new Set([
        ...Object.keys(words_v1),
        ...Object.keys(words_v4)
      ].map(Number))).sort((a, b) => a - b);
      const wordsArr = idxs.map((i) => {
        const key = String(i);
        const code_v1 = words_v1[key] || '';
        const code_v4 = words_v4[key] || null;
        const page = (pages_v4 && pages_v4[key]) || (pages_v1 && pages_v1[key]) || ay.page || null;
        return { page, code_v1, code_v4 };
      });
      return {
        number: ay.numberInSurah,
        end_v1: ay.verse_number_glyph_v1 || null,
        end_v4: ay.verse_number_glyph_v4 || null,
        words: wordsArr
      };
    });
    surah = { alquran_translations: js.alquran_translations, qcf: { words } };
  } else {
    surah = js;
  }
  const value = { surah };
  cache.set(key, value);
  return value;
}

export function getCachedSurah(id) {
  return cache.get(String(id)) || null;
}
